export const en = {
  brand: "Ads Library Downloader",
  nav: {
    dashboard: "Library",
    history: "History",
    export: "Export",
    settings: "Settings",
    extension: "Extension",
    logout: "Sign out",
  },
  library: {
    tagline: "All your ads, in one place",
    search: "Search ads, brands, copy…",
    activeAds: "Active ads",
    platforms: "Platforms",
    brands: "Brands",
    asset: "Asset",
    sort: "Sort",
    display: "Display",
    tags: "Tags",
    days: "days",
    day: "day",
    active: "Active",
    savedAgo: "Saved {n} {unit} ago",
    empty: "Your library is empty. Install the extension and click SAVE on any ad from Meta Ad Library to get started.",
    adLibrary: "Ad Library",
    landing: "Landing page",
    boards: "BOARDS",
  },
  auth: {
    signInTitle: "Sign in",
    signInSubtitle: "Access your Meta Ad Library download dashboard.",
    signUpTitle: "Create account",
    signUpSubtitle: "Start organizing your creatives in minutes.",
    email: "Email",
    password: "Password",
    name: "Name",
    signIn: "Sign in",
    signUp: "Create account",
    noAccount: "No account?",
    hasAccount: "Already have an account?",
    createOne: "Create one",
    signInNow: "Sign in",
    forgot: "Forgot password",
    welcomeBack: "Welcome back!",
    accountCreated: "Account created!",
  },
  stats: {
    totalDownloads: "Total downloads",
    images: "Images",
    videos: "Videos",
    monitoredAds: "Monitored ads",
    advertisers: "Advertisers",
    countries: "Countries",
  },
  history: {
    title: "Download history",
    subtitle: "Filter, search, and re-download any creative you captured.",
    search: "Search advertiser, headline, filename…",
    advertiser: "Advertiser",
    country: "Country",
    type: "Type",
    date: "Date",
    file: "File",
    actions: "Actions",
    all: "All",
    image: "Image",
    video: "Video",
    redownload: "Re-download",
    empty: "No downloads yet. Install the extension to get started.",
    filters: "Filters",
  },
  export: {
    title: "Export",
    subtitle: "Download your history and creatives as CSV, JSON, or ZIP.",
    csv: "Download CSV",
    json: "Download JSON",
    zip: "Download ZIP (metadata + media)",
    zipHint: "The ZIP includes a metadata.json plus files under Brand/Campaign/[imagens|videos].",
  },
  settings: {
    title: "Settings",
    subtitle: "Preferences shared between the extension and dashboard.",
    defaultFolder: "Default folder",
    parallelLimit: "Parallel downloads",
    namingTemplate: "Naming template",
    autoRetry: "Auto retry",
    maxRetries: "Max retries",
    language: "Language",
    theme: "Theme",
    themeLight: "Light",
    themeDark: "Dark",
    save: "Save",
    saved: "Settings saved.",
  },
  extension: {
    title: "Chrome extension",
    subtitle: "Install the extension and connect to your dashboard in 3 steps.",
    step1: "Download the extension bundle (.zip) and extract it locally.",
    step2: "Open chrome://extensions, enable Developer mode and click Load unpacked.",
    step3: "In the extension popup, paste the API URL and access token below and enable Sync history.",
    download: "Download extension (.zip)",
    apiUrl: "API URL",
    token: "Access token",
    copy: "Copy",
    copied: "Copied!",
    version: "Version",
  },
  common: {
    loading: "Loading…",
    filter: "Filter",
    clear: "Clear",
    all: "All",
    close: "Close",
  },
};
